export default {
    collapseButton: {
        "collapse": "Reduzieren",
        "expand": "Erweitern"
    }
};
